// Textos pequenos que se repetem nas telas (web e apps).

/** "1 pedido" · "3 pedidos" · "0 pedidos". */
export function plural(n: number, singular: string, pluralDe: string): string {
  return `${n} ${n === 1 ? singular : pluralDe}`;
}

const CONECTIVOS = new Set(['da', 'das', 'de', 'do', 'dos', 'e']);

/** "Maria Souza" → "MS" · "Gás do Bairro" → "GB" · "Carlos" → "C". Para o avatar sem foto. */
export function iniciais(nome: string): string {
  const palavras = nome
    .trim()
    .split(/\s+/)
    .filter((p) => p && !CONECTIVOS.has(p.toLocaleLowerCase('pt-BR')));
  const primeira = palavras[0];
  if (!primeira) return '?';
  const ultima = palavras.length > 1 ? palavras[palavras.length - 1] : undefined;
  return `${primeira.charAt(0)}${ultima?.charAt(0) ?? ''}`.toLocaleUpperCase('pt-BR');
}

/** Mensagens do Supabase Auth (em inglês) → frase em português para a tela de entrar. */
export function traduzirErroAuth(mensagem: string): string {
  if (/invalid login credentials/i.test(mensagem)) return 'E-mail ou senha incorretos.';
  if (/email not confirmed/i.test(mensagem))
    return 'Confirme seu e-mail antes de entrar: o link foi para a sua caixa de entrada.';
  if (/rate limit|too many|security purposes/i.test(mensagem))
    return 'Muitos pedidos seguidos. Espere alguns minutos e tente de novo.';
  if (/already registered|already been registered/i.test(mensagem))
    return 'Este e-mail já tem conta. Entre.';
  if (/already linked|identity.*already exists|identity_already_exists/i.test(mensagem))
    return 'Esta conta já está ligada a outro cadastro. Saia e entre com ela.';
  if (/provider is not enabled|unsupported provider|manual linking is disabled/i.test(mensagem))
    return 'Este jeito de entrar ainda não está disponível. Use o e-mail.';
  if (/token has expired|otp.*(expired|invalid)|invalid.*otp/i.test(mensagem))
    return 'Código inválido ou vencido. Confira ou peça outro.';
  if (/network|fetch|failed to fetch/i.test(mensagem))
    return 'Sem conexão. Confira a internet e tente de novo.';
  if (/different from the old password|same_password/i.test(mensagem))
    return 'A senha nova precisa ser diferente da atual.';
  if (/weak|easy to guess|pwned/i.test(mensagem))
    return 'Essa senha é fácil de adivinhar. Escolha outra.';
  if (/at least \d+ characters|password.*(short|length)/i.test(mensagem))
    return 'A senha precisa ter pelo menos 8 caracteres.';
  if (/password/i.test(mensagem)) return 'Não deu para usar essa senha. Escolha outra.';
  if (/email/i.test(mensagem)) return 'Confira o e-mail.';
  return 'Não foi possível entrar agora. Tente de novo.';
}
